import React from 'react';

export const name = 'flag-CZ';

export const FlagCZ = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_89)">
      <mask
        id="mask0_2_89"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_89)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M10.9547 12L3.51562 20.4844C5.19384 22.1622 7.33186 23.3048 9.65944 23.7677C11.987 24.2306 14.3995 23.993 16.592 23.0849C18.7845 22.1767 20.6585 20.639 21.9771 18.6659C23.2957 16.6928 23.9996 14.3731 24 12H10.9547Z"
          fill="#D80027"
        />
        <path
          d="M3.51561 3.51562C1.26573 5.766 0.00180054 8.81784 0.00180054 12C0.00180054 15.1822 1.26573 18.234 3.51561 20.4844L12 12L3.51561 3.51562Z"
          fill="#0052B4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_89">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
